import MultiStepForm from "components/MultiStepForm";
import FormStep from "components/MultiStepForm/FormStep";
import { getUsers, getTeamMembers } from "data/user/actions";
import { selectCanCreate, selectIsPaidUser, selectUserId, selectPlanMrcByPin, selectPlanTypesByUserType, selectVendorPhoneNumber, selectBillingDashboard } from "data/user/selectors";
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { FormProvider } from "../../../context/FormContext";
import LeaveMessagePopup from "../modals/LeaveMessage";
import mainCss from "../style.scss";
import ChooseTier from "./chooseTier";
import CreateTeamProfile from "./createTeamProfile";
import ReviewTeam from "./reviewTeam";
import SuccessTeamProfile from "./successTeamProfile";
import { chooseCreateTeamDefaultValue, chooseTierDefaultValue, profileValidationSchema, reviewTeamValidationSchema, step1ValidationSchema } from "./validationSchemas";
import {  createTeamMemberAPI,checkEmailAvailabilityAPI } from "data/user/actions";
import encryptPassword from 'utils/passwordValidation';
import { numberOfDaysFromToday } from "../../../utils/date/formatDate";
import CVV99Modal from "../components/cvv99Modal";

const TeamScreen = ({ history, leaveMessagePopup, leaveMessagePopupClose }) => {

  const userID = useSelector(selectUserId)

  const isPaidUser = useSelector(selectIsPaidUser)
  const canCreate = useSelector(selectCanCreate)
  const vendorPhoneNumber = useSelector(selectVendorPhoneNumber);
  const [formData, setFormData] = useState({});
  const [showCVVModal, setShowCVVModal] = useState(false);
  const [storedNextStep, setStoredNextStep] = useState(null);

  const dashboardBilling = useSelector(selectBillingDashboard)

  const dispatch = useDispatch();

  useEffect(() => {
    const navigationEntries = window.performance.getEntriesByType("navigation");
    const isReload = navigationEntries?.length > 0 && navigationEntries[0]?.type === "reload";

    if (isReload) {
      console.log("Page was reloaded");
      if (userID) {
        dispatch(getTeamMembers(userID));
      }
    }

    return () => {
      leaveMessagePopupClose();
    }
  }, [userID]);

  const steps = [
    {
      component: (
        <FormStep defaultValues={chooseTierDefaultValue} CancelButtonLabel="Cancel" showCancelButton={true} showNextButton={false}>
          <ChooseTier />
        </FormStep>
      ),
      validationSchema: step1ValidationSchema,
      screen: '1'
    },
    {
      component: (
        <FormStep defaultValues={chooseCreateTeamDefaultValue} backButtonLabel="Back to Tiers">
          <CreateTeamProfile />
        </FormStep>
      ),
      validationSchema: profileValidationSchema,
      screen: '2'
    },
    {
      component: (
        <FormStep backButtonLabel="Back to Profile" continueButtonLabel={"Confirm Changes"}>
          <ReviewTeam />
        </FormStep>
      ),
      validationSchema: reviewTeamValidationSchema,
      isSubmissionStep: true,
      screen: '3'
    },
    {
      component: (
        <FormStep backButtonLabel="Back to Profile" showBackButton={false} continueButtonLabel="Return to Account Home">
          <SuccessTeamProfile />
        </FormStep>
      ),
      validationSchema: reviewTeamValidationSchema,
      isRedirectStep: true,
      screen: '4'
    },
  ];



  const handleNextStep = async (formData, nextStep, currentStep) => {
    if (currentStep?.screen === "2") {
    try {
        // handle card check
        if(formData?.type === "TEAM_FULL" && !formData?.defaultSubsPaymentMethodId && !formData?.defaultInAppPaymentMethodId){
          leaveMessagePopup({
            title: "Error",
            message: `Please add payment method under "Billing" section before proceeding.`,
            yesLable: "Ok",
            cancelLable: null,
            CancelRedirect: () => null,
            yesRedirect: () => null,
        });
        return;
      }
      // Email availability check
      const resp = await checkEmailAvailabilityAPI(formData.username, userID);

      if (resp?.data?.emailExists) {
        leaveMessagePopup({
          title: "Error",
          message: `User email already exists.`,
          yesLable: "Ok",
          cancelLable: null,
          CancelRedirect: () => null,
          yesRedirect: () => null,
        });
        return;
      }

      // Spending/Property limit check
      if (
        formData?.type !== "SCOUT" &&
        (!formData?.spendingLimit || !formData?.propertyLimit)
      ) {
        leaveMessagePopup({
          title: "Proceed Without Setting Team Member Limits?",
          message:
            "Your Team Member will have unlimited access to Saves, Exports and Spending.",
          autoWidth: false,
          CancelRedirect: () => null, // Stay on the same step
          yesRedirect: () => nextStep(), // ✅ Only proceed if user confirms
        });
        return;
      }

      // If both checks pass, go to next step
      if (typeof nextStep === "function") nextStep();
      return;
    } catch (err) {
      console.error("Email check failed:", err);
      leaveMessagePopup({
        title: "Error",
        message: err?.message || "Unable to verify email. Please try again.",
        yesLable: "Ok",
        cancelLable: null,
        CancelRedirect: () => null,
        yesRedirect: () => null,
      });
      return;
    }
  }

    // chooseTier

    if (
      currentStep?.screen === "1" && formData?.type !== "SCOUT"
    ) {

      if (canCreate && isPaidUser) {
        leaveMessagePopup({
          title: "Are you sure want to proceed?",
          message: "Each additional user will cost $30.",
          CancelRedirect: () => null, // Stay on the same step
          yesRedirect: () => nextStep(), // Move to the next step
        });
        return; // Prevent navigation until the user selects an option
      } else {
        if (canCreate) {

        } else {
          leaveMessagePopup({
            title: "Maximum Limit of Full Access Team Members Reached.",
            message: `Please contact Customer Support at ${vendorPhoneNumber} if you need more.`,
            autoWidth : false,
            yesLable: "Ok",
            cancelLable: "",
            CancelRedirect: () => null, // Stay on the same step
            yesRedirect: () => null, // Move to the next step
          });
          return; // Prevent navigation until the user selects an option
        }

      }

    }

    if (currentStep?.screen !== "3" && typeof nextStep === "function") {
      nextStep(); // Move to the next step if no popup is needed
    }
  };


  const handleSubmit = async (finalData, nextStep, cardCode = '') => {
    try {
      console.log("Submitting: ", finalData);
      setFormData(finalData); // Update formData in context
      if (typeof nextStep === 'function') {
        setStoredNextStep(() => nextStep);
      }
      if (finalData?.type === "TEAM_FULL" && finalData?.paymentMethodId && !cardCode) {
          setShowCVVModal(true);
          return;
      }
      const resp = await handleCreateTeamMember(finalData);

      if (resp?.success) {
        if (typeof nextStep === "function") {
          nextStep();
        }
      } else {
        leaveMessagePopup({
          title: "Error",
          message: resp?.error,
          yesLable: "Ok",
          cancelLable: null,
          CancelRedirect: () => null, // Stay on the same step
          yesRedirect: () => null, // Move to the next step
        });
        console.error(resp?.error);
      }
    } catch (err) {
      console.error("Submission error: ", err);
      leaveMessagePopup({
        title: "Error",
        message: err?.message,
        yesLable: "Ok",
        cancelLable: null,
        CancelRedirect: () => null, // Stay on the same step
        yesRedirect: () => null, // Move to the next step
      });
      //alert("An error occurred while submitting the form.");
      throw err;
    }
  };

  const handleCreateTeamMember = async (userDetails, cardCode = "") => {
    let payload = {
      ...userDetails,
      userId: userID,
      username: userDetails?.username?.trim()?.toLowerCase(),
      confirmEmail: userDetails?.confirmEmail?.toLowerCase(),
      newPwd: encryptPassword(userDetails?.newPwd),
      securityDomainId: 1,
      agreeToTerms: true
    };
    // console.log(paln)

       if (userDetails?.type === "SCOUT") {
        payload = {
          ...payload,
          approvedAmount: 0,
          planMrcId: userDetails?.planMrcId,
          defaultInAppPaymentMethodId: null,
          defaultSubsPaymentMethodId: null,
          profilePicture: userDetails?.profilePicture ? userDetails?.profilePicture : [],
          paymentMethodId: null
        };
        delete payload.propertyLimit;
        delete payload.spendingLimit;
      } else {
        payload = {
          ...payload,
          planMrcId: userDetails?.planMrcId,
          paymentMethodId: userDetails?.paymentMethodId ? Number(userDetails?.paymentMethodId) : null,
          profilePicture: userDetails?.profilePicture ? userDetails?.profilePicture : [],
          defaultInAppPaymentMethodId: userDetails?.defaultInAppPaymentMethodId ? Number(userDetails?.defaultInAppPaymentMethodId) : null,
          defaultSubsPaymentMethodId: userDetails?.defaultSubsPaymentMethodId ? Number(userDetails?.defaultSubsPaymentMethodId) : null,
          approvedAmount: userDetails?.paymentMethodId ? (userDetails?.planMrc?.prorateAmount) : 0,
          propertyLimit: userDetails?.propertyLimit ? Number(userDetails?.propertyLimit) : null,
          spendingLimit: userDetails?.spendingLimit ? Number(userDetails?.spendingLimit) : null,
          pushToBatchDialer: userDetails?.pushToBatchDialer || false,
          allowClickToDial: userDetails?.allowClickToDial || false,
        }
        if (cardCode) {
          payload.cardCode = cardCode;
        }
      }

   delete payload?.confirmEmail
   delete payload?.confirmPassword
   delete payload?.plan
    try {
      const response = await createTeamMemberAPI(payload);
      if (response.success) {
        setShowCVVModal(false);
        dispatch(getUsers());
        console.log("create successful:", response.teamMember);
        return { success: true, error: null};
      } else {
        setShowCVVModal(false);
        console.error("create failed:", response.error);
        return { success: false, error: response.error };
      }
    } catch (error) {
      setShowCVVModal(false);
      console.error("Unexpected error:", error);
      return { success: false, error: "Something went wrong!" };
    }
  };


  const handleCancel = (currentStep = "") => {
    if (currentStep?.screen !== "1" && !canCreate) {
      leaveMessagePopup({
        CancelRedirect: () => null,
        yesRedirect: () => history.push("/accountnew/landing"),
      });
    } else {
      history.push("/accountnew/landing")
    }
  };

  return (
    <div className={mainCss.clsInnerMainBody}>
      <div>
        <FormProvider>
          <MultiStepForm steps={steps} onSubmit={handleSubmit} onCancel={handleCancel} history={history} redirectPath="/accountnew/landing"
            onNext={handleNextStep}
          />
        </FormProvider>

        {showCVVModal && <CVV99Modal
          showCVVModal={showCVVModal} cardEnding={formData?.selectedPayment?.cardEnding} cvvLength={formData?.selectedPayment?.cardCVVLength} handleSubmitCVV={({ cardCode }) => handleSubmit(formData, storedNextStep, cardCode)}
          handleCancel={() => setShowCVVModal(false)} handleClose={() => setShowCVVModal(false)} />}
      </div>
    </div>
  );
};


export default withRouter(connect(null, {
  leaveMessagePopup: LeaveMessagePopup.open,
  leaveMessagePopupClose: LeaveMessagePopup.close
})(TeamScreen));
